// External
import '../../styles/mui-button.scss';
import '../../styles/mui-select.scss';
import '../../styles/tabs.scss';

import React, {Component} from "react";
import {connect} from "react-redux";
import "rc-time-picker/assets/index.css";
import Moment from "moment";
import {getFilterStateFromParams, updateUrlWithFilters} from "../../utils/uriParams";
import DatePicker from "react-datepicker";
import {withRouter} from "../../utils/withRouter";

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCalendarAlt, faFilter, faMapMarkerAlt, faSpinner} from '@fortawesome/free-solid-svg-icons';

// Internal
import FloatHeader from "../theme/headers/FloatHeader";
import ColorCheckbox from "../theme/forms/ColorCheckbox";
import {defaultMapState} from "./CreateSite";
import {useThemeMode} from "../../theme/ThemeProvider";
import "../../styles/printMap.scss";

import BaseMapSimple from "../maps/BaseMapSimple";
import TimelineLegend from "../maps/controls/TimelineLegend";
import api from "../../store/api/api";
import CanvasserSideBarItem from "../maps/listItems/CanvasserSideBarItem";
import TimelineListItem from "../maps/listItems/TimelineListItem";
import FeedbackTile from "../theme/modals/FeedbackTile";


export const legendStyles = {
    log_in: {
        color: "#5e1313", staticColor: "0x5e1313",
    }, log_out: {
        color: "#9e2020", staticColor: "0x9e2020",
    }, check_in: {
        color: "#1f78b4", staticColor: "0x1f78b4",
    }, check_out: {
        color: "#e31a1c", staticColor: "0xe31a1c",
    }, log_response: {
        color: "#6a3d9a", staticColor: "0x6a3d9a",
    }, create_site: {
        color: "#ffbe00", staticColor: "0xffbe00",
    }, location_update: {
        color: "#cab2d6", staticColor: "0xcab2d6",
    }, door_canvass: {
        color: "#fbb034", staticColor: "0xfbb034",
    }, site_contact_attempt: {
        color: "#33a02c", staticColor: "0x33a02c",
    }, inactive: {
        color: "black",
    }
};

//map status to class names in css
export const legendClassMapping = {
    log_in: "login",
    log_out: "logout",
    check_in: "blue",
    check_out: "red",
    log_response: "purple",
    create_site: "orange",
    door_canvass: "magenta",
    location_update: "lilac",
    site_contact_attempt: "green",
    inactive: "grey",
};

export const EventTypeLabelMap = {
    log_in: "Login",
    log_out: "Logout",
    check_in: "Checkins",
    check_out: "Checkouts",
    log_response: "Responses",
    create_site: "New Sites",
    door_canvass: "Door Canvassed",
    location_update: "Location Update",
    site_contact_attempt: "Attempts",
    inactive: "inactive",
}

const CustomMuiDateInput = ({value, onClick, isLoading}) => (
    <button onClick={onClick}
            className={'mui-button underline-primary fullwidth has-end-icon'}>
        {value || <span style={{opacity: 0.7, margin: "0 1em"}}>--</span>}
        {isLoading === true ? <div className="start-icon"><FontAwesomeIcon
                icon={faSpinner} spin/></div> :
            <FontAwesomeIcon icon={faCalendarAlt} className={'end-icon'}/>}
    </button>
);

class TrackingMap extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...defaultMapState,
            tab: 'filters',
            showOfficeList: true,
            hoveredEvent: null,
            showLocationAsPoints: false,
            plotTypes: {offices: true, locations: true, sites: true, events: true, humans: true},
            noGeoCanvassers: [],
            allEventData: [], allLocationData: [],
            allCanvassers: [],
            allSiteCanvasses: [],
            mapCenter: null,
            distanceThreshold: 50,
            ...getFilterStateFromParams(props.location),
            mapDrawTrigger: new Date().getTime(),
            loading: {offices: true, canvassers: true, events: false, sites: false, locations: false, sitecanvasses: true}
        };
    }

    // Get current theme mode from document attribute
    getCurrentThemeMode = () => {
        return document.documentElement.getAttribute('data-theme') === 'dark';
    }

    componentDidMount() {
        this.reloadData();
        
        // Listen for theme changes to re-render the map
        this.themeObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'data-theme') {
                    this.setState({ mapDrawTrigger: new Date().getTime() });
                }
            });
        });
        
        this.themeObserver.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['data-theme']
        });
    }

    componentWillUnmount() {
        if (this.themeObserver) {
            this.themeObserver.disconnect();
        }
    }

    reloadData() {
        const params = this.buildReportParams();
        this.loadSiteCanvasses(params); // orm
        this.loadOffices(params) // stored procedure
        this.loadCanvassers(params)  // stored procedure
        this.loadLocationData(params) // orm
        this.loadEventData(params);
    }

    // Create the query params object used in api request
    buildReportParams() {
        let params = {
            campaign: +this.props.focusedCampaign.id,
            start: new Moment(this.state.start).format("YYYY-MM-DD"),
            end: new Moment(this.state.start).format("YYYY-MM-DD"),
            map: true,
        };

        // If an office has been chosen add it to the query params
        if (this.state.selectedOffice > -1) {
            params.office = this.state.selectedOffice;
        }
        if (this.state.selectedCanvasser > -1) {
            params.canvasser = this.state.selectedCanvasser;
        }

        return params;
    }

    loadCanvassers(params) {
        if (!params) params = this.buildReportParams();

        this.setState({loading: {...this.state.loading, canvassers: true}});
        api.get('/aggregates/canvassers', params)
            .then((res) => {
                if (res.data.rows.length === 0) return this.setState({allCanvassers: []});
                this.setState({allCanvassers: res.data.rows});

            })
            .catch((err) => {
                console.log(err);
                window.alert("Error loading canvassers");
            }).finally(() => {
            this.setState({mapDrawTrigger: new Date().getTime(), loading: {...this.state.loading, canvassers: false}});
        })
    }

    loadOffices(params) {
        if (!params) params = this.buildReportParams();

        this.setState({loading: {...this.state.loading, offices: true}});
        api.get('/aggregates/offices', params)
            .then((res) => {
                if (res.data.rows.length === 0) {
                    return this.setState({offices: []});
                }
                this.setState({offices: res.data.rows});
            })
            .catch((err) => {
                console.log(err);
                window.alert("Error loading offices");
            }).finally(() => {
            this.setState({mapDrawTrigger: new Date().getTime(), loading: {...this.state.loading, offices: false}});
        })
    }


    loadSiteCanvasses(params) {
        if (!params) params = this.buildReportParams();

        this.setState({loading: {...this.state.loading, sitecanvasses: true}});
        api.get('/sitecanvasses', params)
            .then((res) => {
                if (res.data.length === 0) return this.setState({
                    sites: []
                });
                // sort necessary for binary search
                this.setState({allSiteCanvasses: res.data.sort((a, b) => a.id < b.id)});
            })
            .catch((err) => {
                console.log(err);
                window.alert("Error loading sites");
            }).finally(() => {
            this.setState({mapDrawTrigger: new Date().getTime(), loading: {...this.state.loading, sitecanvasses: false}});
        })
    }

    loadLocationData(params) {
        if (this.state.loading['locations'] === true) {
            return null;
        }
        if (this.state.selectedCanvasser < 1) {
            this.setState({allLocationData: []});
            return null;
        }

        this.setState({loading: {...this.state.loading, locations: true}});

        if (!params) params = this.buildReportParams();
        params.event_types = 'location_update';

        api.get('/map-events/', params)
            .then((res) => {
                const allLocationData = res.data;
                let noGeoCanvassers = {};
                allLocationData.forEach((d) => {
                    if (!d.longitude || !d.latitude) {
                        // TODO: track how long GPS is off
                        noGeoCanvassers[d.canvasser_id] = d;
                    }
                });
                this.setState({allLocationData: allLocationData, noGeoCanvassers: Object.values(noGeoCanvassers)});
            })
            .catch((err) => {
                console.log(err);
                window.alert("Error loading locations");
            }).finally(() => {
            this.setState({mapDrawTrigger: new Date().getTime(), loading: {...this.state.loading, locations: false}});
        })
    }

    loadEventData(params) {
        if (this.state.loading['events'] === true) {
            return null;
        }

        this.setState({loading: {...this.state.loading, events: true}});

        if (!params) params = this.buildReportParams();
        params.event_types = 'events';

        api.get('/map-events/', params)
            .then((res) => {
                this.setState({allEventData: res.data});
            })
            .catch((err) => {
                console.log(err);
                window.alert("Error loading events");
            }).finally(() => {
            this.setState({mapDrawTrigger: new Date().getTime(), loading: {...this.state.loading, events: false}});
        })
    }


    filterEventMarkers() {
        const validPoints = [];
        const sitesToPlot = {};
        const humansToPlot = {};
        if (this.state.allEventData) {
            // const sortedPoints = this.state.allEventData.sort((a, b) => new Date(a.phone_time).getTime() - new Date(b.phone_time).getTime());

            this.state.allEventData.forEach((point) => {
                if (point.longitude && point.latitude && Math.abs(point.longitude) > 0 && Math.abs(point.latitude) > 0) {
                    if (this.state.selectedOffice > 0 && point.office_id !== this.state.selectedOffice) {
                        // do not include
                    } else if (this.state.selectedCanvasser > 0 && point.canvasser_id !== this.state.selectedCanvasser) {
                        // do not include
                    } else if (!this.state.canvasser_events[point.event_type]) {
                        // do not include
                    } else {
                        validPoints.push(point);
                        if (point.site_id && point.site_lat && point.site_lon && !sitesToPlot[point.site_id]) {
                            sitesToPlot[point.site_id] = {
                                site_id: point.site_id,
                                site_lat: point.site_lat,
                                site_lon: point.site_lon,
                                site_name: point.site_name,
                            };
                        }

                        if (point.canvasser_id) {
                            humansToPlot[point.canvasser_id] = {
                                canvasser_id: point.canvasser_id,
                                canvasser_name: point.canvasser_name || (point.canvasser_firstname + ' ' + point.canvasser_lastname),
                                latitude: point.latitude,
                                longitude: point.longitude,
                                phone_time: point.phone_time,
                                event_time: point.event_time,
                                event_type: point.event_type
                            };
                        }
                    }
                }
            })
        } else {
            console.log("NO DATA TO FILTER");
        }
        if (this.state.allLocationData) {
            // const sortedPoints = this.state.allEventData.sort((a, b) => new Date(a.phone_time).getTime() - new Date(b.phone_time).getTime());

            this.state.allLocationData.forEach((point) => {
                if (point.longitude && point.latitude && Math.abs(point.longitude) > 0 && Math.abs(point.latitude) > 0) {
                    if (this.state.selectedOffice > 0 && point.office_id !== this.state.selectedOffice) {
                        // do not include
                    } else if (this.state.selectedCanvasser > 0 && point.canvasser_id !== this.state.selectedCanvasser) {
                        // do not include
                    } else if (!this.state.canvasser_events[point.event_type]) {
                        // do not include
                    } else {
                        validPoints.push(point);
                        if (point.site_id && point.site_lat && point.site_lon) {
                            sitesToPlot[point.site_id] = {
                                site_id: point.site_id,
                                site_lat: point.site_lat,
                                site_lon: point.site_lon,
                                site_name: point.site_name,
                            };
                        }
                        if (point.canvasser_id && point.canvasser_name) {
                            humansToPlot[point.canvasser_id] = {
                                canvasser_id: point.canvasser_id,
                                canvasser_name: point.canvasser_name || (point.canvasser_firstname + ' ' + point.canvasser_lastname),
                                latitude: point.latitude,
                                longitude: point.longitude,
                                phone_time: point.phone_time,
                                event_time: point.event_time,
                                event_type: point.event_type
                            };
                        }
                    }
                }
            })
        } else {
            console.log("NO DATA TO FILTER");
        }

        return { validPoints, sitesToPlot: Object.values(sitesToPlot), humansToPlot: Object.values(humansToPlot) };
    }

    handleOfficeSelectChange(e) {
        this.setState({
            selectedOffice: parseInt(e.target.value)
        }, () => {
            updateUrlWithFilters(this.props.history, this.state);
            this.reloadData()
        });
    }

    handleDateChange = (start) => {
        this.setState({start, end: start}, () => {
            updateUrlWithFilters(this.props.history, this.state);
            this.reloadData()
        });
    };

    handleCheckboxChange(event_key) {
        let canvasser_events = {...this.state.canvasser_events};
        canvasser_events[event_key] = !canvasser_events[event_key];
        this.setState({
            canvasser_events
        }, () => {
            updateUrlWithFilters(this.props.history, this.state);
        });
    }

    handleCanvasserSelectChange(canvasser_id) {
        this.setState({
            selectedCanvasser: parseInt(canvasser_id)
        }, () => {
            updateUrlWithFilters(this.props.history, this.state);
            this.loadLocationData()
            this.loadEventData()
        });
    }

    handleSiteSelectChange(site_id) {
        if (!site_id) return;
        
        const { sitesToPlot } = this.filterEventMarkers();
        const selectedSite = sitesToPlot.find(s => s.site_id === site_id);
        
        if (selectedSite && selectedSite.site_lat && selectedSite.site_lon) {
            // Center the map on the selected site
            this.setState({
                mapDrawTrigger: new Date().getTime()
            });
            
            // Use a timeout to ensure the map is ready, then center on the site
            setTimeout(() => {
                const mapContainer = document.getElementById('MapContainer');
                if (mapContainer) {
                    // Trigger a custom event or use the map's flyTo method
                    // Since we're using BaseMapSimple, we'll need to pass the center coordinates
                    // through the mapDrawTrigger or create a new prop for centering
                    this.centerMapOnSite(selectedSite.site_lon, selectedSite.site_lat);
                }
            }, 100);
        }
    }

    centerMapOnSite(longitude, latitude) {
        // This method will be called to center the map on a specific site
        // We'll need to modify BaseMapSimple to accept center coordinates
        this.setState({
            mapCenter: { longitude, latitude },
            mapDrawTrigger: new Date().getTime()
        });
    }

    buildCounts() {
        if (!this.state.allEventData) return {total: 0, total_filtered: 0};
        const counts = this.state.allEventData.reduce((acc, event) => {
            acc[event.event_type] = (acc[event.event_type] || 0) + 1;
            acc['total']++;
            return acc;
        }, {total: 0, total_filtered: 0});
        if (this.state.allLocationData) {
            counts['location_update'] = this.state.allLocationData.length;
        }
        return counts;
    }


    // build color coded event checkboxes in sidebar
    renderEventLegend() {
        let legend = [];
        let canvasser_events = {...this.state.canvasser_events};
        const counts = this.buildCounts();

        for (let key in canvasser_events) {
            let active = canvasser_events[key];
            let colorClass = "";

            if (active) {
                colorClass = legendClassMapping[key];
            } else {
                colorClass = legendClassMapping["inactive"];
            }

            let label = EventTypeLabelMap[key]
            if (key === 'location_update') {
                if (this.state.selectedCanvasser < 1) {
                    label = 'Last Location';
                }
                label = <React.Fragment>{label} <small>({counts[key]})</small></React.Fragment>

                legend.push(<React.Fragment>
                    <ColorCheckbox
                        className={colorClass}
                        handleChange={this.handleCheckboxChange.bind(this, key)}
                        value={active}
                        title={label}
                        key={`legendcheckbox-${key}`}
                    />
                    {this.state.canvasser_events['location_update'] && this.state.selectedCanvasser > 0 &&
                        <button onClick={() => this.setState({showLocationAsPoints: !this.state.showLocationAsPoints})}
                                className={'mui-button small outlined-secondary'} style={{marginLeft: 30}}>
                            {this.state.showLocationAsPoints ? "As Timeline" : "As points"}
                        </button>
                    }
                </React.Fragment>);

            } else {
                if (counts[key]) {
                    label = <React.Fragment>{label} <small>({counts[key]})</small></React.Fragment>
                }

                legend.push(<ColorCheckbox
                    className={colorClass}
                    handleChange={this.handleCheckboxChange.bind(this, key)}
                    value={active}
                    title={label}
                    key={`legendcheckbox-${key}`}
                />);
            }
        }
        return legend;
    }

    renderCanvasserSideBar() {
        let content = 'loading canvassers...';
        if (this.state.allCanvassers) {
            content = this.state.allCanvassers.map((canvasser) => {
                return <CanvasserSideBarItem key={`canvasserside-${canvasser.canvasser_id}`}
                                             data={canvasser}
                                             showTimes={true}
                                             onMouseEnter={() => this.showCanvasserOnMap(canvasser)}
                                             focused={this.state.selectedCanvasser === canvasser.canvasser_id}
                                             onTitleClick={() => this.handleCanvasserSelectChange(canvasser.canvasser_id)}/>
            })
        }
        return content;
    }

    renderSideBarData() {
        let content = 'loading events...';
        if (this.state.allEventData) {
            const { validPoints } = this.filterEventMarkers()
            content = validPoints.map((event) => {
                if (event.event_type === 'location_update') return null;
                // TODO: Pass in Door, Response data
                const canvasser = this.state.selectedCanvasser > -1 ? false : this.state.allCanvassers.find(a => a.canvasser_id === event.canvasser_id); // can't binary search unless sorted by ID
                let target = false;
                if (event.site_lat && event.site_lon) {
                    target = {
                        name: event.site_name,
                        lat: event.site_lat,
                        lon: event.site_lon,
                        id: event.site_id,
                        type: 'site'
                    }
                } else {
                    const iSite = this.binarySearch(this.state.allSiteCanvasses, event.sitecanvass_id, 'id');
                    if (iSite > -1) {
                        target = {...this.state.allSiteCanvasses[iSite]}; // currently just sitecanvass data with no lat/lng
                        const office = this.state.offices.find(o => o.id === site.office_id);
                        if (office) {
                            target.type = 'site'
                            target.lat = office.lat
                            target.lon = office.lon
                        } else {
                            target = false;
                        }
                    }
                }

                return <TimelineListItem key={`event-timeline-${event.id}`}
                                         data={event}
                                         showTimes={true}
                                         canvasser={canvasser}
                                         target={target}
                                         onMouseEnter={() => this.showEventOnMap(event)}
                                         focused={this.state.hoveredEvent?.id === event.id}
                                         onTitleClick={() => this.showEventOnMap(event)}/>


            })
        }
        return content
    }

    renderSideBarFilters() {
        return (<div className="side-bar-scroll">
            <div className="side-menu-title">
                <div className="fieldWrapper">
                    <h5 style={{marginBottom: 5}}>Event Types</h5>
                    {this.renderEventLegend()}
                </div>

                <div className="fieldWrapper">
                    <h5 style={{marginBottom: 5, marginTop: 30}}>Distance Threshold</h5>
                    <input
                        type="number"
                        min={1}
                        onChange={(e) => this.setState({distanceThreshold: e.target.value})}
                        value={this.state.distanceThreshold}
                    />
                </div>

            </div>
        </div>);
    }

    renderOfficeOptions() {
        const options = [<option key={"default_option"} value={-1}>
            All Offices
        </option>];

        if (!this.state.offices) return options;

        this.state.offices.forEach((d) => {
            options.push(<option key={d.name + "_office_" + d.id} value={d.id}
                                 selected={this.state.selectedOffice === d.id}>
                {d.name}
            </option>);
        });

        return options;
    }

    renderCanvasserOptions() {
        const options = [<option key={"default_option"} value={-1}>
            {this.state.loading.canvassers ? 'Loading Canvassers' :
                `All ${this.state.allCanvassers.length} Canvassers`
            }
        </option>];

        if (!this.state.allCanvassers) return options;

        this.state.allCanvassers.forEach((d) => {
            options.push(<option key={"selectcanvasser_" + d.canvasser_id} value={d.canvasser_id}
                                 selected={this.state.selectedCanvasser === d.canvasser_id}>
                {d.canvasser_name} ({d.achieved + d.attempted})
            </option>);
        });

        return options;
    }

    renderSiteOptions() {
        const { sitesToPlot } = this.filterEventMarkers();
        const options = [<option key={"default_option"} value="">
            Select a Site
        </option>];

        if (sitesToPlot.length === 0) {
            options.push(<option key={"no_sites"} value="" disabled>
                No sites available
            </option>);
            return options;
        }

        sitesToPlot.forEach((site) => {
            options.push(<option key={"selectsite_" + site.site_id} value={site.site_id}>
                {site.site_name || `Site ${site.site_id}`}
            </option>);
        });

        return options;
    }

    returnEmptyCollection() {
        return {
            type: "FeatureCollection", features: []
        };
    }

    calculateDistance = (point1, point2) => {
        const lon1 = point1[0], lat1 = point1[1];
        const lon2 = point2[0], lat2 = point2[1];

        // Convert to radians
        const φ1 = lat1 * Math.PI / 180;
        const φ2 = lat2 * Math.PI / 180;
        const Δφ = (lat2 - lat1) * Math.PI / 180;
        const Δλ = (lon2 - lon1) * Math.PI / 180;

        // Haversine formula
        const R = 6371e3; // Earth's radius in meters
        const a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
            Math.cos(φ1) * Math.cos(φ2) *
            Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        return R * c; // Distance in meters
    };

    encodeTimeline = (validPoints) => {
        if (!this.state.selectedCanvasser) {
            return this.returnEmptyCollection();
        }

        if (!validPoints?.length) {
            return this.returnEmptyCollection();
        }

        const toPlot = validPoints.filter(point => point.event_type === 'location_update')
        if (toPlot.length === 0) return this.returnEmptyCollection();

        // Create two features - one for the continuous gradient line and one for gaps
        const gradientFeature = {
            type: "Feature",
            geometry: {
                type: "LineString",
                coordinates: []
            },
            properties: {
                timestamps: [],
                eventTypes: [],
                startTime: toPlot[0].phone_time,
                endTime: toPlot[toPlot.length - 1].phone_time,
                useGradient: true,
                isGap: false
            }
        };

        const gapFeatures = [];
        let currentGap = null;

        // Process points into segments
        for (let i = 0; i < toPlot.length - 1; i++) {
            const point1 = [toPlot[i].longitude, toPlot[i].latitude];
            const point2 = [toPlot[i + 1].longitude, toPlot[i + 1].latitude];
            const distance = this.calculateDistance(point1, point2);

            // Always add to the main gradient line
            if (i === 0) {
                gradientFeature.geometry.coordinates.push(point1);
            }
            gradientFeature.geometry.coordinates.push(point2);

            // If distance exceeds threshold, create a gap feature
            if (distance > this.state.distanceThreshold) {
                gapFeatures.push({
                    type: "Feature",
                    geometry: {
                        type: "LineString",
                        coordinates: [point1, point2]
                    },
                    properties: {
                        timestamps: [toPlot[i].phone_time, toPlot[i + 1].phone_time],
                        eventTypes: [toPlot[i].event_type, toPlot[i + 1].event_type],
                        startTime: toPlot[i].phone_time,
                        endTime: toPlot[i + 1].phone_time,
                        useGradient: false,
                        isGap: true
                    }
                });
            }
        }

        return {
            type: "FeatureCollection",
            features: [gradientFeature, ...gapFeatures]
        };
    };

    encodePoints = (toPlot) => {
        if (!toPlot?.length) {
            return this.returnEmptyCollection()
        }

        if (toPlot.length === 0) return this.returnEmptyCollection();
        // console.log("toPlot points", toPlot[0])

        return {
            type: "FeatureCollection", features: toPlot.map((point) => {
                return {
                    type: "Feature", id: point.id, source: 'eventtype-symbols',
                    geometry: {type: "Point", coordinates: [point.longitude, point.latitude]},
                    properties: {data: point, groupColor: legendStyles[point.event_type]?.color || "black"},
                };
            }),
        };
    };


    encodeLastCanvasserLocations = () => {
        const collection = this.returnEmptyCollection()
        if (!this.state.allCanvassers.length) {
            return collection;
        }

        this.state.allCanvassers.forEach(canvasser => {
            if (canvasser.longitude && canvasser.latitude && Math.abs(canvasser.longitude) > 0 && Math.abs(canvasser.latitude) > 0) {
                collection.features.push({
                    type: "Feature", id: canvasser.canvasser_id, source: 'canvasser-location-symbols',
                    geometry: {
                        type: "Point",
                        coordinates: [canvasser.longitude, canvasser.latitude]
                    },
                    properties: {data: canvasser, groupColor: legendStyles['location_update'].color},
                });
            }
        });

        return collection
    };

    encodeOfficeIcons = (offices) => {
        let toPlot = offices;
        if (this.state.selectedOffice > 0) {
            toPlot = this.state.offices.find(o => o.id === this.state.selectedOffice);
            if (toPlot) toPlot = [toPlot];
            else return this.returnEmptyCollection();
        } else if (this.state.selectedCanvasser > 0) {
            if (this.state.offices.length > 1) {
                return this.returnEmptyCollection(); // plotting multiple offices makes the zooming wrong and allCanvassers doesn't have an office_id
            }
        }

        return {
            type: "FeatureCollection", features: toPlot.map((office) => {
                return {
                    type: "Feature", id: office.id, source: "office-symbols",
                    geometry: {type: "Point", coordinates: [office.lon, office.lat]},
                    properties: {
                        data: office,
                        iconName: "star"
                    },
                };
            }),
        };
    };

    encodeSites = (sitesToPlot) => {
        if (!sitesToPlot || sitesToPlot.length === 0) {
            return this.returnEmptyCollection();
        }

        return {
            type: "FeatureCollection", 
            features: sitesToPlot.map((site) => {
                return {
                    type: "Feature", 
                    id: site.site_id, 
                    source: "site-symbols",
                    geometry: {
                        type: "Point", 
                        coordinates: [site.site_lon, site.site_lat]
                    },
                    properties: {
                        data: site,
                        iconName: "homeFilled"
                    },
                };
            }),
        };
    };

    encodeHumans = (humansToPlot) => {
        if (!humansToPlot || humansToPlot.length === 0) {
            return this.returnEmptyCollection();
        }

        return {
            type: "FeatureCollection", 
            features: humansToPlot.map((human) => {
                return {
                    type: "Feature", 
                    id: human.canvasser_id, 
                    source: "human-symbols",
                    geometry: {
                        type: "Point", 
                        coordinates: [human.longitude, human.latitude]
                    },
                    properties: {
                        data: human,
                        iconName: "person"
                    },
                };
            }),
        };
    };

    compileMapFeatures() {
        const base = this.returnEmptyCollection();
        let markers = []
        const { validPoints, sitesToPlot, humansToPlot } = this.filterEventMarkers();

        if (this.state.plotTypes['offices'] && this.state.offices && this.state.offices.length > 0) {
            markers = this.encodeOfficeIcons(this.state.offices)
            base.features = base.features.concat(markers.features);
        }

        if (this.state.plotTypes['sites'] && sitesToPlot) {
            markers = this.encodeSites(sitesToPlot)
            base.features = base.features.concat(markers.features);
        }

        if (this.state.plotTypes['humans'] && humansToPlot) {
            markers = this.encodeHumans(humansToPlot)
            base.features = base.features.concat(markers.features);
        }

        if (this.state.plotTypes['locations']) {
            if (this.state.selectedCanvasser > 0) {
                if (this.state.showLocationAsPoints === false) {
                    markers = this.encodeTimeline(validPoints)
                } else {
                    markers = this.encodePoints(validPoints)
                }
            } else {
                markers = this.encodeLastCanvasserLocations()
            }
            base.features = base.features.concat(markers.features);
        }

        if (this.state.plotTypes['events']) {
            const eventPoints = validPoints.filter(p => p.event_type !== 'location_update');
            markers = this.encodePoints(eventPoints)
            base.features = base.features.concat(markers.features);
        }

        return base
    }


    binarySearch = (arr, target, key) => {
        let left = 0, right = arr.length - 1;
        while (left <= right) {
            let mid = Math.floor((left + right) / 2);
            const val = new Date(arr[mid][key]).getTime();
            if (val === target) return mid;
            if (val < target) left = mid + 1;
            else right = mid - 1;
        }
        return -1;
    };

    showCanvasserOnMap(canvasser) {
        this.setState({hoveredEvent: canvasser});
    }

    showEventOnMap(event) {
        this.setState({hoveredEvent: event});
    }

    // Add an onMouseLeave handler to clear the hover state
    clearHoveredCanvasser = () => {
        console.log('leaving event')
        this.setState({hoveredEvent: null});
    }

    handlePinClick = (eventData) => {
        console.log("CLICKED ON ", eventData)
        const elId = this.state.selectedCanvasser > 0 ? `event-action-${eventData.id}` : `sidebar-canvasser-${eventData.canvasser_id}`;
        const element = document.getElementById(elId);
        if (element) {
            element.scrollIntoView({behavior: 'smooth', block: 'center'});
            // Add temporary highlight class
            element.classList.add('highlight-pulse');
            setTimeout(() => {
                element.classList.remove('highlight-pulse');
            }, 2000);
        }
    }

    handlePinHover = (eventData) => {
        console.log("HOVERING ON ", eventData)
        const elId = this.state.tab === 'events' ? `event-action-${eventData.id}` : `sidebar-canvasser-${eventData.canvasser_id}`;
        this.setState({hoveredEvent: eventData});
        const element = document.getElementById(elId);
        if (element) {
            element.scrollIntoView({behavior: 'smooth', block: 'center'});
            // Add temporary highlight class
            element.classList.add('highlight-pulse');
            setTimeout(() => {
                element.classList.remove('highlight-pulse');
            }, 2000);
        }
    }

    handlePinLeave = () => {
        this.setState({hoveredEvent: null});
    }


    getNoGeoWarningText = () => {
        if (this.state.noGeoCanvassers.length === 0) return null;
        let nameList = this.state.noGeoCanvassers.map((c) => {
            return `${c.canvasser_firstname} ${c.canvasser_lastname}`;
        });
        const names = `${nameList.join(', ')} have GPS turned off and are not displayed.`;

        return <FeedbackTile
            text={
                <div style={{fontSize: "11px"}}>
                    <i
                        className="fas fa-exclamation-triangle"
                        style={{marginRight: "15px"}}
                    />
                    {names}
                </div>
            }
            visible={true}
            classNames="danger"
        />
    };

    render() {
        let loading = this.state.loading;

        return (<div className="map-report-print-wrapper">
            <FloatHeader link="/dash" />
            {this.state.plotTypes['locations'] && this.state.selectedCanvasser > 0 && <TimelineLegend/>}

            <div id={'MapContainer'} style={{width: "100vw", height: "100vh"}}>
                <BaseMapSimple
                    features={this.compileMapFeatures()}
                    hoveredEvent={this.state.hoveredEvent}
                    onPinClick={this.handlePinClick}
                    onPinHover={this.handlePinHover}
                    onPinLeave={this.handlePinLeave}
                    mapDrawTrigger={this.state.mapDrawTrigger}
                    mapCenter={this.state.mapCenter}
                    isDarkMode={this.getCurrentThemeMode()}
                />
            </div>
            <div className={`no-print map-side-menu ${this.state.sideBarClosed && "closed"}`}>
                <div className="side-menu-wrapper" id="side-menu-scroll-wrapper">
                    <div className="fieldWrapper">
                        <h5>Date</h5>
                        <div>
                            <DatePicker
                                selected={Moment(this.state.start, this.SUBMIT_DATE_FORMAT).toDate()}
                                onChange={this.handleDateChange}
                                minDate={new Date(2020, 0, 20)}
                                maxDate={new Date()}
                                todayButton="Today"
                                customInput={<CustomMuiDateInput value={this.state.start}
                                                                 onClick={this.handleDateChange}
                                                                 isLoading={this.state.selectedCanvasser > 0 && this.state.loading.events === true}/>}
                            />
                        </div>
                    </div>
                    <div className="fieldWrapper">
                        <h5>Offices</h5>
                        <div className="mui-select standard-primary">
                            {this.state.loading['offices'] && <div className="start-icon"><FontAwesomeIcon
                                icon={faSpinner} spin/></div>}
                            <select
                                id="office-report-select"
                                value={this.state.selectedOffice}
                                onChange={this.handleOfficeSelectChange.bind(this)}
                            >
                                {this.renderOfficeOptions()}
                            </select>
                        </div>
                    </div>
                    <div className="fieldWrapper">
                        <h5>Canvassers</h5>
                        <div className="mui-select standard-primary">
                            {this.state.loading['canvassers'] && <div className="start-icon"><FontAwesomeIcon
                                icon={faSpinner} spin/></div>}
                            <select
                                id="canvasser-report-select"
                                value={this.state.selectedCanvasser}
                                onChange={(e) => this.handleCanvasserSelectChange(e.target.value)}
                            >
                                {this.renderCanvasserOptions()}
                            </select>
                        </div>
                    </div>

                    <div className="fieldWrapper">
                    <h5>Center on Site</h5>
                    <div className="mui-select standard-primary">
                        <select
                            id="site-center-select"
                            onChange={(e) => this.handleSiteSelectChange(e.target.value)}
                            defaultValue=""
                        >
                            {this.renderSiteOptions()}
                        </select>
                    </div>
                </div>


                    <div className="tabs-container" id={'SideBarData'}>
                        {this.state.selectedCanvasser > 0 ?
                            <React.Fragment>
                                <ul className="tabs-list">

                                    <li onClick={() => this.setState({tab: 'events'})}
                                        className={`tab primary ${this.state.tab === 'events' ? 'active' : ''}`}>
                                        {this.state.allEventData.filter(a => typeof EventTypeLabelMap[a.event_type] === 'string').length} Events <span
                                        className="start-icon"><FontAwesomeIcon
                                        icon={faMapMarkerAlt}/></span>
                                    </li>

                                    <li onClick={() => this.setState({tab: 'filters'})}
                                        className={`tab primary ${this.state.tab === 'filters' ? 'active' : ''}`}>
                                        Filters <span className="start-icon"><FontAwesomeIcon icon={faFilter}/></span>
                                    </li>

                                </ul>
                                <div className="tab-panel active">
                                    {this.state.tab === 'filters' ? this.renderSideBarFilters() : this.renderSideBarData()}
                                </div>
                            </React.Fragment>
                            :
                            <div className="tab-panel active">
                                {this.renderCanvasserSideBar()}
                            </div>
                        }

                    </div>
                </div>
                <div className={`side-menu-select-wrapper ${this.state.sideBarClosed && "closed"}`}>
                    <div
                        className="side-menu-option toggle"
                        style={{marginTop: "12vh"}}
                        onClick={() => this.setState({sideBarClosed: !this.state.sideBarClosed})}
                    >
                        <i
                            className={`fas ${this.state.sideBarClosed ? "fa-arrow-left" : "fa-arrow-right"}`}
                        />
                    </div>
                    {(loading.canvassers || loading.locations || loading.sites ||  loading.sitecanvasses || (loading.events && this.state.selectedCanvasser > 0)) && (
                        <div className={`side-menu-option loading`}>
                            <i className="fas fa-asterisk"/>
                        </div>)}
                </div>
                {this.getNoGeoWarningText()}
            </div>
        </div>);
    }
}

const mapStateToProps = (state) => ({
    focusedCampaign: state.session.focusedCampaign
});

export default withRouter(connect(mapStateToProps, null)(TrackingMap));
